var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolyline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2078_1132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.16669 1.74976V5.24976H2.88752L4.05419 8.74976H3.50002V12.2498H7.00002V9.57226L10.1559 6.41642H12.8334V2.91642H9.33335V5.58226L6.17752 8.74976H5.28502L4.11835 5.24976H4.66669V1.74976H1.16669ZM2.33335 2.91642H3.50002V4.08309H2.33335V2.91642ZM10.5 4.08309H11.6667V5.24976H10.5V4.08309ZM12.3375 7.58309C12.25 7.58309 12.1742 7.61226 12.11 7.67642L11.5209 8.27142L12.7284 9.47892L13.3234 8.88976C13.4459 8.76726 13.4459 8.55726 13.3234 8.43476L12.565 7.67642C12.5009 7.61226 12.4192 7.58309 12.3375 7.58309ZM11.1709 8.60976L7.58335 12.1973V13.4164H8.80252L12.3842 9.82309L11.1709 8.60976ZM4.66669 9.91642H5.83335V11.0831H4.66669V9.91642Z",
    fill: "#242424"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2078_1132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 -0.000244141)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyline);
export default __webpack_public_path__ + "static/media/polyline.e7f9dbeb932f1a930621e63f66171ed1.svg";
export { ForwardRef as ReactComponent };